<app-no-result
  [icon]="'notifications'"
  [title]="noDataTitle"
  [description]="noDataTitle"
  [isButton]="false"
></app-no-result>
